<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">複数コード登録</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="column-list">
          <label class="list-input-title">画像ファイル名</label>
          <div class="list-input-content">
            <input type="text" id="txti_ImageFileName" #txti_ImageFileName class="text-label-required" 
              plessInputTextSub  [halfOnly]="true" [maxLength]="12" style="width: 12rem;"
              [tabindex]="0" [(ngModel)]="kymw1708Model.imageFileName"
              (ngModelChange)="eventImageFileName_deleteCommaHandler($event)">
            <button id="btn_Image" class="btn-secondary" (click)="eventDisplay_CLICKHandler()"
              [tabindex]="0">表示</button>
          </div>
        </div>
        <div>
          <img src="{{kymw1708Model.imagePreviewUrl}}" *ngIf="kymw1708Model.imagePreviewUrl != ''" 
            id="img_MultiCode" (load)="setImageScale()">
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Update" class="btn-primary" (click)="eventRegist_CLICKHandler()">登録</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>